const Solicitar = () => {
  return (
    <div className="relative w-full p-12">
        <h2 className="text-2xl md:text-5xl text-center text-[#028299] font-bold my-12">
          Hablemos de su proyecto
        </h2>
      <form className="w-full rounded-xl p-6 grid grid-cols-2 gap-4">
        <input
          type="text"
          placeholder="Nombre completo"
          className="border-0 bg-sky-300/50 placeholder:text-slate-400 text-black px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="email"
          placeholder="Correo electrónico"
          className="border-0 bg-sky-300/50 placeholder:text-slate-400 text-black px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="tel"
          placeholder="Teléfono"
          className="border-0 bg-sky-300/50 placeholder:text-slate-400 text-black px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="text"
          placeholder="Ciudad desde la que escribe"
          className="border-0 bg-sky-300/50 placeholder:text-slate-400 text-black px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <textarea
          rows="4"
          placeholder="Mensaje"
          className="col-span-2 border-0 bg-sky-300/50 placeholder:text-slate-400 text-black px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400 resize-none"
        ></textarea>

        <button
          type="submit"
          className="col-span-2 w-64 mx-auto bg-gray-500 text-white py-3 rounded-full font-semibold hover:bg-sky-800 transition"
        >
          Enviar solicitud
        </button>
      </form>
    </div>
  );
};

export default Solicitar;
